export default __webpack_public_path__ + "static/media/ML.52bb233b.svg";